import Axios from 'axios'
import {
  SYSMENU_UNSET_ALL_STATE,
  SYSMENU_SET_MSG,
  SYSMENU_UNSET_MSG,
  SYSMENU_SET_SCHEMA,
  SYSMENU_UNSET_SCHEMA,
  SYSMENU_SET_ACTION_PROCESS,
  SYSMENU_UNSET_ACTION_PROCESS,
  SYSMENU_SET_LIST_DATA,
  SYSMENU_UNSET_LIST_DATA,
  SYSMENU_SET_ACTION_STATUS,
  SYSMENU_UNSET_ACTION_STATUS

} from '../mutation-types'

const state = {
  dataList: [],
  message: '',
  actionStatus: false,
  actionProcess: false,
  Schema: {
    id: 0,
    menu_name: '',
    css_class: '',
    route: '',
    menu_url: '',
    sl_no: '',
    active: 1,
    dashboard:0,
  }
}

const getters = {
  get_SYSMENU_DataList(state) {
    return state.dataList;
  },
  get_SYSMENU_ActionMessage(state) {
    return state.message;
  },
  get_SYSMENU_Schema(state) {
    return state.Schema
  },
  get_SYSMENU_ActionProcess(state) {
    return state.actionProcess;
  },
  get_SYSMENU_ActionStatus(state) {
    return state.actionStatus;
  },

}

// mutations

const mutations = {
  [SYSMENU_UNSET_ALL_STATE](state) {
    state.actionProcess = false,
      state.dataList = [],
      state.Schema = {
        id: 0,
        sl_no: '',
        active: 1,
        menu_name: '',
        css_class: '',
        route: '',
        menu_url: '',        
        dashboard:0,
      }
  },
  [SYSMENU_SET_ACTION_STATUS](state) {
    state.actionStatus = true
  },
  [SYSMENU_UNSET_ACTION_STATUS](state) {
    state.actionStatus = false
  },
  [SYSMENU_SET_MSG](state, msg) {
    state.message = msg
  },
  [SYSMENU_UNSET_MSG](state) {
    state.message = ""
  },
  [SYSMENU_UNSET_ACTION_PROCESS](state) {
    state.actionProcess = false
  },
  [SYSMENU_SET_ACTION_PROCESS](state) {
    state.actionProcess = true
  },
  [SYSMENU_SET_LIST_DATA](state, itemList) {
    state.dataList = itemList
  },
  [SYSMENU_UNSET_LIST_DATA](state) {
    state.dataList = []
  },
  [SYSMENU_SET_SCHEMA](state, schemaData) {
    state.Schema = schemaData
  },
  [SYSMENU_UNSET_SCHEMA](state) {
    state.Schema = []
    state.Schema.active = 1
  },
}

// Actions

const actions = {
 

}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/dia_sysMenu_module.js